import React, { useState, useEffect, useRef } from 'react';
import '../../../styles/homepagecss/Copilot.css';


const HomeCopilot = () => {
  const [activeGroup, setActiveGroup] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [typingText, setTypingText] = useState('');
  const [showResponse, setShowResponse] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const sectionRef = useRef(null);

  const copilotGroups = [
    {
      id: 1,
      title: 'Real-Time Decision Support',
      subtitle: 'Payer meeting in 2 hours?',
      question: ' Summarize our value story vs. competitors with supporting RCT evidence',
      narrative: 'Your drug demonstrates superior efficacy with 28% ORR vs. 15% for Competitor A (p<0.001, KEYNOTE-189). Safety profile shows 12% Grade 3+ AEs compared to 18% industry average. Cost per responder: $42K vs. $67K (Competitor B). ICER of $85K/QALY falls within NICE acceptable range.',
      layout: 'graph-table', // col-6 graph + col-6 table
      graph: (
        <div className="graph-card">
          <div className="graph-header">
            <p className="ev-reg-p-dark ev-bold-reg mb-0">Overall Response Rate Comparison</p>
          </div>
          <div className="graph-visual bar-chart">
            <div className="bar-item vh-10" style={{ background: 'var(--color9)'}}></div>
            <div className="bar-item vh-5" style={{background: 'var(--color14)'}}></div>
            <div className="bar-item vh-3" style={{ background: 'var(--color12)'}}></div>
            <div className="bar-item vh-8" style={{ background: 'var(--color10)'}}></div>
            <div className="bar-item vh-5" style={{background: 'var(--color14)'}}></div>
            <div className="bar-item vh-10" style={{ background: 'var(--color9)'}}></div>
            <div className="bar-item vh-3" style={{ background: 'var(--color12)'}}></div>
            <div className="bar-item vh-8" style={{ background: 'var(--color14)'}}></div>
            <div className="bar-item vh-3" style={{ background: 'var(--color10)'}}></div>
            <div className="bar-item vh-5" style={{background: 'var(--color12)'}}></div>
            <div className="bar-item vh-10" style={{ background: 'var(--color9)'}}></div>
            <div className="bar-item vh-5" style={{ background: 'var(--color14)'}}></div>
            <div className="bar-item vh-8" style={{ background: 'var(--color10)'}}></div>
            <div className="bar-item vh-5" style={{ background: 'var(--color12)'}}></div>
            <div className="bar-item vh-8" style={{background: 'var(--color9)'}}></div>
          </div>
          <div className="graph-footer">
            <span className="ev-fs-11 ev-reg-p-blue">Phase 3 RCT efficacy data</span>
          </div>
        </div>
      ),
      table: `
        <table class="home-copilot-response-table">
          <thead>
            <tr>
              <th>Drug</th>
              <th>ORR (%)</th>
              <th>Grade 3+ AEs (%)</th>
              <th>Cost/Responder</th>
              <th>ICER</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Your Drug</td>
              <td>28%</td>
              <td>12%</td>
              <td>$42K</td>
              <td>$85K/QALY</td>
            </tr>
            <tr>
              <td>Competitor A</td>
              <td>15%</td>
              <td>18%</td>
              <td>$67K</td>
              <td>$125K/QALY</td>
            </tr>
            <tr>
              <td>Competitor B</td>
              <td>18%</td>
              <td>22%</td>
              <td>$58K</td>
              <td>$110K/QALY</td>
            </tr>
          </tbody>
        </table>
      `,
      references: ['KEYNOTE-189_CSR.pdf', 'Competitor_Analysis_Q4.xlsx', 'NICE_HTA_Submission_v3.docx']
    },
    {
      id: 2,
      title: 'Epidemiology Analysis',
      subtitle: 'Disease Burden Assessment',
      question: 'Forecast Alzheimer\'s prevalence and economic burden across G7 countries for next decade',
      narrative: 'Prevalence grows from 8.2M (2025) to 12.8M (2035) across G7 nations—a 56% increase. Japan shows steepest demographic pressure (42% growth) while US accounts for largest absolute burden (4.8M by 2035). Direct healthcare costs escalate from $285B to $468B annually, with informal care costs adding $320B by 2035. Germany faces fastest per-capita cost growth at 8.2% CAGR.',
      layout: 'table-only', // Only table, full width
      table: `
        <table class="home-copilot-response-table">
          <thead>
            <tr>
              <th>Country</th>
              <th>2025 Prevalence</th>
              <th>2035 Prevalence</th>
              <th>Growth Rate</th>
              <th>2025 Cost</th>
              <th>2035 Cost</th>
              <th>CAGR</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>USA</td>
              <td>3.2M</td>
              <td>4.8M</td>
              <td>+50%</td>
              <td>$142B</td>
              <td>$228B</td>
              <td>4.8%</td>
            </tr>
            <tr>
              <td>Japan</td>
              <td>2.1M</td>
              <td>3.0M</td>
              <td>+42%</td>
              <td>$68B</td>
              <td>$105B</td>
              <td>4.4%</td>
            </tr>
            <tr>
              <td>Germany</td>
              <td>1.4M</td>
              <td>1.9M</td>
              <td>+36%</td>
              <td>$38B</td>
              <td>$72B</td>
              <td>6.6%</td>
            </tr>
            <tr>
              <td>UK</td>
              <td>0.9M</td>
              <td>1.3M</td>
              <td>+44%</td>
              <td>$24B</td>
              <td>$38B</td>
              <td>4.7%</td>
            </tr>
            <tr>
              <td>France</td>
              <td>0.8M</td>
              <td>1.1M</td>
              <td>+38%</td>
              <td>$19B</td>
              <td>$31B</td>
              <td>5.0%</td>
            </tr>
          </tbody>
        </table>
      `,
      references: ['WHO_Dementia_Report_2024.pdf', 'OECD_Health_Statistics.xlsx', 'Alzheimers_Disease_International_2025.pdf']
    },
    {
      id: 3,
      title: 'Market Access Intelligence',
      subtitle: 'HTA Requirements Mapping',
      question: 'Compare orphan drug reimbursement requirements and evidence gaps across NICE, G-BA, and HAS',
      narrative: 'NICE demands comparative effectiveness with PSA sensitivity (£100-300K/QALY threshold for ultra-rare). G-BA requires additional benefit demonstration but offers flexible endpoints for rare diseases. HAS accepts single-arm trials with external controls and emphasizes ASMR ratings. Key evidence gaps: all three bodies require long-term durability data (5-year minimum) and real-world evidence within 2 years post-approval.',
      layout: 'multi-viz', // 2 graphs (col-4 each) + 1 table (col-4)
      graph1: (
        <div className="graph-card">
          <div className="graph-header">
            <p className="ev-reg-p-dark ev-bold-reg mb-0">Evidence Requirements</p>
          </div>
          <div className="graph-visual pie-chart">
            <svg viewBox="0 0 100 100" className="pie-svg">
              <circle cx="50" cy="50" r="40" fill="none" stroke="var(--color9)" strokeWidth="20" strokeDasharray="45 55" strokeDashoffset="25"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="var(--color14)" strokeWidth="20" strokeDasharray="35 65" strokeDashoffset="-20"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="var(--color12)" strokeWidth="20" strokeDasharray="20 80" strokeDashoffset="-55"></circle>
            </svg>
            <div className="pie-center">
              <span className="ev-fs-15 ev-bold-med gradient-font5">45%</span>
            </div>
          </div>
          <div className="graph-footer">
            <span className="ev-fs-11 ev-reg-p-blue">RWE mandatory</span>
          </div>
        </div>
      ),
      graph2: (
        <div className="graph-card">
          <div className="graph-header">
            <p className="ev-reg-p-dark ev-bold-reg mb-0">Approval Timelines</p>
          </div>
          <div className="graph-visual bar-chart">
            <div className="bar-item vh-8" style={{ background: 'var(--color9)'}}></div>
            <div className="bar-item vh-10" style={{background: 'var(--color14)'}}></div>
            <div className="bar-item vh-6" style={{ background: 'var(--color12)'}}></div>
            <div className="bar-item vh-7" style={{ background: 'var(--color10)'}}></div>
            <div className="bar-item vh-9" style={{background: 'var(--color9)'}}></div>
          </div>
          <div className="graph-footer">
            <span className="ev-fs-11 ev-reg-p-blue">Months to decision</span>
          </div>
        </div>
      ),
      table: `
        <table class="home-copilot-response-table">
          <thead>
            <tr>
              <th>HTA Body</th>
              <th>Comparator</th>
              <th>RWE Timing</th>
              <th>Key Gap</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>NICE (UK)</td>
              <td>Active</td>
              <td>2 years</td>
              <td>Durability</td>
            </tr>
            <tr>
              <td>G-BA (DE)</td>
              <td>SoC</td>
              <td>Flexible</td>
              <td>Comparative</td>
            </tr>
            <tr>
              <td>HAS (FR)</td>
              <td>Flexible</td>
              <td>Post-launch</td>
              <td>Caregiver</td>
            </tr>
            <tr>
              <td>CADTH (CA)</td>
              <td>Active</td>
              <td>1 year</td>
              <td>Budget Impact</td>
            </tr>
          </tbody>
        </table>
      `,
      references: ['NICE_Methods_Guide_2024.pdf', 'G-BA_Orphan_Guidance.pdf', 'HAS_ASMR_Framework_2025.docx']
    }
  ];

  const currentGroup = copilotGroups[activeGroup];

  // Intersection Observer for scroll-triggered animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Typing animation effect
  useEffect(() => {
    if (!isVisible) return;

    setTypingText('');
    setShowResponse(false);
    let currentIndex = 0;
    const question = currentGroup.question;

    const typingInterval = setInterval(() => {
      if (currentIndex <= question.length) {
        setTypingText(question.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => setShowResponse(true), 200);
      }
    }, 20);

    return () => clearInterval(typingInterval);
  }, [activeGroup, isVisible, currentGroup.question]);

  // Auto-switch groups with transition
  useEffect(() => {
    if (!isVisible || !isAutoPlay) return;

    const groupInterval = setInterval(() => {
      handleGroupSwitch((activeGroup + 1) % copilotGroups.length);
    }, 3500);

    return () => clearInterval(groupInterval);
  }, [isVisible, isAutoPlay, activeGroup, copilotGroups.length]);

  const handleGroupSwitch = (newIndex) => {
    if (newIndex === activeGroup) return;
    
    setIsAutoPlay(false);
    setIsTransitioning(true);
    setShowResponse(false);
    
    setTimeout(() => {
      setActiveGroup(newIndex);
      setIsTransitioning(false);
      setTimeout(() => {
        setIsAutoPlay(true);
      }, 100);
    }, 500);
  };

  // Render layout based on type
  const renderVisualization = () => {
    if (currentGroup.layout === 'graph-table') {
      // Layout 1: Graph (col-6) + Table (col-6)
      return (
        <div className="row g-2">
          <div className="col-6">
            {currentGroup.graph}
          </div>
          <div className="col-6">
            <div dangerouslySetInnerHTML={{ __html: currentGroup.table }} />
          </div>
        </div>
      );
    } else if (currentGroup.layout === 'table-only') {
      // Layout 2: Table only (full width)
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: currentGroup.table }} />
        </div>
      );
    } else if (currentGroup.layout === 'multi-viz') {
      // Layout 3: Graph1 (col-4) + Graph2 (col-4) + Table (col-4)
      return (
        <div className="row g-2">
          <div className="col-4">
            {currentGroup.graph1}
          </div>
          <div className="col-3">
            {currentGroup.graph2}
          </div>
          <div className="col-5">
            <div dangerouslySetInnerHTML={{ __html: currentGroup.table }} />
          </div>
        </div>
      );
    }
  };

  return (
    <section className="background-color2 py-2" ref={sectionRef}>
      <div className="container">
        <p className="ev-reg-p-dark ev-fs-17 ev-bold-med mb-1">Ask Genie.</p>
        <p className="gradient-font7 ev-fs-40 margin-bottom-2 col-lg-6 ev-bold-med">Data Intelligence, Simplified.</p>
        <div className="row margin-bottom-2">
          <div className="col-lg-4 col-md-4 col-4">
            <p className="ev-fs-40 ev-reg-p-blue mb-1"><i className="bi bi-layers"></i></p>
            <p className="ev-fs-16 ev-reg-p-dark ev-bold-reg mb-1">Secure, context-aware intelligence</p>
            <p className="ev-fs-15 ev-reg-p-dark ev-reg">Fabric-native permissions. Unlimited conversation history. Document-grounded responses.</p>
          </div>
          <div className="col-lg-4 col-md-4 col-4">
            <p className="ev-fs-40 ev-reg-p-blue mb-1"><i className="bi bi-layers"></i></p>
            <p className="ev-fs-16 ev-reg-p-dark ev-bold-reg mb-1">Private by design</p>
            <p className="ev-fs-15 ev-reg-p-dark ev-reg">Your chats. Your eyes only. Conversation history is user-specific.</p>
          </div>
          <div className="col-lg-4 col-md-4 col-4">
            <p className="ev-fs-40 ev-reg-p-blue mb-1"><i className="bi bi-layers"></i></p>
            <p className="ev-fs-16 ev-reg-p-dark ev-bold-reg mb-1">RAG-powered accuracy</p>
            <p className="ev-fs-15 ev-reg-p-dark ev-reg">Answers grounded in your data pool. Not hallucinations.</p>
          </div>
        </div>

        <div className="row ev-card-2 ev-padding-med">
          <div className="col-lg-4 col-md-3 col-3">
            <div className="home-copilot-group-tiles">
              {copilotGroups.map((group, idx) => (
                <div
                  key={group.id}
                  className={`group-tile ${activeGroup === idx ? 'active' : ''}`}
                  onClick={() => handleGroupSwitch(idx)}
                >
                  <div className="ev-reg-p-dark ev-fs-15 mb-1">{group.title}</div>
                  <div className="ev-reg-p-dark ev-fs-13 ev-reg">{group.subtitle}</div>
                  {activeGroup === idx && (
                    <div className="active-indicator">
                      <i className="bi bi-chevron-right"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-8 col-md-9 col-9">
            <div className="ev-padding-med">
              <div className={`home-copilot-question-box mb-2 ${isVisible && !isTransitioning ? 'show' : ''} ${isTransitioning ? 'slide-up' : ''}`}>
                <div className="question-icon">
                  <i className="bi bi-person-fill"></i>
                </div>
                <div className="question-content">
                  <span className="question-text">{typingText}</span>
                  <span className="typing-cursor">|</span>
                </div>
              </div>

              <div className={`home-copilot-response-box ${showResponse && !isTransitioning ? 'show' : ''} ${isTransitioning ? 'slide-up' : ''}`}>
                <div>
                  <p className="response-narrative">{currentGroup.narrative}</p>
                </div>

                <div>
                  {renderVisualization()}
                </div>

                <div className="response-section">
                  <div className="ev-message-card6 ev-btn-small mb-2">References</div>
                  <div className="references-list">
                    {currentGroup.references.map((ref, idx) => (
                      <span key={idx} className="reference-badge">
                        {ref}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCopilot;